import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from '../../vdms_core/services/vehicle/vehicle.data.services';
import { FuelcardService } from '../../vdms_core/services/api/fuelcard.service';


@Component({
  selector: 'app-add-fuel-card-details',
  templateUrl: './add-fuel-card-details.component.html',
  styleUrls: ['./add-fuel-card-details.component.css']
})
export class AddFuelCardDetailsComponent implements OnInit {

  fuelCardForm: FormGroup;
  isViewMode: boolean = false;
  isEditMode: boolean = false;
  isUnassigned: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public dataService: DataService,
    private fuelCardService: FuelcardService,
  ) { }

  ngOnInit() {
    this.checkInit();
  }
  
  checkInit() {
    const existingData = this.dataService.getRecord();

    // Ensure existingData is not null or undefined before proceeding
    if (existingData && existingData['isViewMode'] !== undefined) {
      this.isViewMode = existingData['isViewMode'];
      this.editForm(existingData);
    } else {
      // If existingData is null/undefined or does not have relevant keys, proceed accordingly
      if (existingData && Object.keys(existingData).length > 0) {
        this.isEditMode = true;
        if(existingData.status != 'UNASSIGN') {
          this.isUnassigned = false;
        }
        this.editForm(existingData);
      } else {
        this.initializeForm();
      }
    }
    this.dataService.clearRecord();
  }

  initializeForm() {
    this.fuelCardForm = this.formBuilder.group({
      card_number: new FormControl('', Validators.required),
      card_provider: new FormControl('', Validators.required),
      card_expiry_date: new FormControl('', Validators.required)
    });
  }

  editForm(existingDataBinding: any): void {
    this.fuelCardForm = this.formBuilder.group({
      id: [existingDataBinding.id, [Validators.required]],// new FormControl(existingDataBinding.id),
      card_number: [existingDataBinding.card_number, [Validators.required]],
      card_provider: [existingDataBinding.card_provider, [Validators.required]],
      card_expiry_date: [existingDataBinding.card_expiry_date, [Validators.required]],
    });
  }

  removeSpaces(event: any, controlName: string) {
    const value = event.target.value;
    const newValue = value.replace(/\s/g, ''); // Remove spaces
    this.fuelCardForm.get(controlName).setValue(newValue); // Update form control value
  }

  savefuelCard() {
    const value = this.fuelCardForm.value;
    if(this.isEditMode) {
      this.fuelCardService.updateFuelMasterCard(value);
    } else {
      this.fuelCardService.createFuelMasterCard(value);
    }
    this.navigate();
  }

  navigate() {
    this.router.navigate(['/pages/fuel-card-details'])
  }

}
